import { render, staticRenderFns } from "./LearnerTranscript.vue?vue&type=template&id=5f3d9d38&lang=html&"
import script from "./LearnerTranscript.vue?vue&type=script&lang=ts&"
export * from "./LearnerTranscript.vue?vue&type=script&lang=ts&"
import style0 from "./LearnerTranscript.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports